'use client'

import { StyledCallout } from './callout.styles'
import { Box, Stack } from '@mui/material'

export const Callout = ({ children, cta, ...props }) => {
  return (
    <StyledCallout {...props}>
      <Stack height="100%" justifyContent="space-between">
        <Box>{children}</Box>
        {cta && <>{cta}</>}
      </Stack>
    </StyledCallout>
  )
}
